import React, { useEffect, useState } from "react";
import axios from "axios"; // Import axios for API calls
import { toast } from "react-toastify"; // Import toast

// Use the environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddCustomer() {
  const [customerName, setCustomerName] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerMobileNo, setCustomerMobileNo] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [generatedCustomerCode, setGeneratedCustomerCode] = useState(null); // State to hold the generated customer code
  const [organization, setUserOrganization] = useState(""); // List of organizations for Main Admin
  const [location, setUserLocation] = useState("");
  const [userRole, setUserRole] = useState(""); // State to store user role
  const [whatsappAllowed, setWhatsappAllowed] = useState(true); // default true

  useEffect(() => {

    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }

        const userResponse = await axios.get(`${API_BASE_URL}/users/specific`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setUserRole(userResponse.data.role); // Set the user role
        setUserLocation(userResponse.data.location); // Set the user's location
        setUserOrganization(userResponse.data.organization)
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Error fetching user data.");
      }
    };

    fetchUserData();

    console.log("userRole:",userRole);
    console.log("locations:",location);
    console.log("organizations:",organization);

  }, []);

  // Validate email format
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Validate phone number format (10 digits after +94)
  // const isValidPhoneNumber = (number) => {
  //   const phoneRegex = /^[1-9][0-9]{8}$/; // 10 digits excluding the first 0
  //   return phoneRegex.test(number);
  // };

  // Handle form submission
  const handleAddCustomer = async () => {
    // Validate required fields
    if (!customerName) {
      toast.error("Customer Name is required.");
      return;
    }
    if (!customerEmail || !isValidEmail(customerEmail)) {
      toast.error("Please enter a valid email address.");
      return;
    } 
    // if (!customerMobileNo || !isValidPhoneNumber(customerMobileNo)) {
    //   toast.error(
    //     "Please enter a valid 10-digit mobile number (e.g., 777567889)."
    //   );
    //   return;
    // }
    if (!customerType) {
      toast.error("Customer Type is required.");
      return;
    }

    const formData = {
      customer_name: customerName,
      cus_address: customerAddress,
      cus_mobileno: `${customerMobileNo}`, // Prefix with +94
      cus_email: customerEmail,
      customer_type: customerType,
      organization: organization,
      location: location,
      whatsapp_allowed: whatsappAllowed,
    };

    console.log("Customer formData:", formData);

    const apiUrl = `${API_BASE_URL}/customers/add`;

    try {
      const token = localStorage.getItem("token"); // Retrieve token from localStorage
      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        return;
      }

      const response = await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "application/json", // Use JSON instead of multipart/form-data
          Authorization: `Bearer ${token}`, // Include token in Authorization header
        },
      });

      console.log("response:", response);

      const { message, customer } = response.data;

      toast.success(message || "Customer added successfully!"); // Display success toast
      console.log("Customer added successfully!");
    

      // Set the generated unit code from the response
      setGeneratedCustomerCode(customer.customer_code);
      
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const { message, details } = error.response.data;

        if (details?.organization_name) {
          // Show specific error for duplicate customer in another organization
          toast.error(
            `${message} (Organization: ${details.organization_name})`
          );
        } else {
          // Generic error message
          toast.error(message || "Error adding customer.");
        }
      } else {
        toast.error("Failed to add customer. Please try again.");
      }
    }
  };

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <div>
          <h2 className="text-2xl font-bold text-green-700 mb-6">
            Add Customer
          </h2>
          <div className="grid grid-cols-2 gap-8"></div>
          {/* Left Column */}
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Customer Name</label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter customer name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Customer Address
              </label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter customer address"
                value={customerAddress}
                onChange={(e) => setCustomerAddress(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Customer Mobile No
              </label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter customer mobile no"
                value={customerMobileNo}
                onChange={(e) => setCustomerMobileNo(e.target.value)}
              />
            </div>
          </div>
          {/* Right Column */}
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Customer Email</label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter customer email"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Customer Type</label>
              <select
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                value={customerType}
                onChange={(e) => setCustomerType(e.target.value)}
              >
                <option value="" disabled>
                  Select Status
                </option>
                <option value="Distributor">Distributor</option>
                <option value="Dealer">Dealer</option>
                <option value="Consumer">Consumer</option>
              </select>
            </div>
          </div>
          <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              id="whatsappAllowed"
              className="mr-2 h-5 w-5"
              checked={whatsappAllowed}
              onChange={(e) => setWhatsappAllowed(e.target.checked)}
            />
            <label htmlFor="whatsappAllowed" className="text-gray-700">
              Allow WhatsApp messages for sending request orders
            </label>
          </div>
          {/* Display the generated organization code if available */}
          {generatedCustomerCode && (
            <div className="mt-4 p-4 bg-gray-100 rounded-lg">
              <p className="text-green-700 font-bold">
                Generated Customer Code: {generatedCustomerCode}
              </p>
            </div>
          )}
        </div>
        {/* {toast.error && <p className="text-red-500">{toast.error}</p>}
        {toast.message && <p className="text-green-500">{toast.message}</p>} */}
      </div>
      <div className="flex space-x-4 mt-6">
        <button
          className="px-6 py-3 bg-green-700 text-white rounded-lg hover:bg-green-700"
          onClick={handleAddCustomer}
        >
          Add Customer
        </button>
      </div>
    </div>
  );
}

export default AddCustomer;
